export const formatUSD = (value = 0): string => {
  return `$${value.toFixed(2)}`;
};
